"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

// Get a Babel location mixin for the given node.
exports.default = function getLoc(node) {
  if (node.loc) {
    return {
      start: node.start,
      end: node.end,
      loc: Object.assign({}, node.loc)
    };
  }
};


//////////////////
// WEBPACK FOOTER
// ../~/ast-loc-utils/lib/getLoc.js
// module id = 986
// module chunks = 0